import React, { type FC } from 'react'

import { SEO_IDS } from './constants'

type MetaDescriptionProps = {
  readonly description: string
}

export const MetaDescription: FC<MetaDescriptionProps> = ({ description }) => {
  if (!description) {
    return null
  }

  return (
    <>
      <meta content={description} id={SEO_IDS.DESCRIPTION} name="description" />
      <meta
        content={description}
        id={SEO_IDS.OG_DESCRIPTION}
        name="og:description"
      />
      <meta
        content={description}
        id={SEO_IDS.TWITTER_DESCRIPTION}
        name="twitter:description"
      />
    </>
  )
}
